module.exports = __webpack_public_path__ + "img/slide10.0cbfc722.png";